define("calendar/types/bttp", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.bttpReportNameMap = _exports.BttpReportName = _exports.BTTP_TRIAL_DURATION_HOURS = _exports.BTTP_TRIAL_CACHE_KEY = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  let BttpReportName = _exports.BttpReportName = /*#__PURE__*/function (BttpReportName) {
    BttpReportName["Tiktok"] = "tt-bttp";
    BttpReportName["Instagram"] = "ig-bttp";
    BttpReportName["Facebook"] = "fb-bttp";
    return BttpReportName;
  }({}); // Record is based off socialProfile.profileType -- Record<SocialProfileModel['profileType'], BttpReportName>
  const bttpReportNameMap = _exports.bttpReportNameMap = {
    tiktok: BttpReportName.Tiktok,
    instagram: BttpReportName.Instagram,
    facebook: BttpReportName.Facebook
    // No other social profile types currently supported for BTTP, but this map can be easily extended in the future to accommodate new platforms
  };
  const BTTP_TRIAL_CACHE_KEY = _exports.BTTP_TRIAL_CACHE_KEY = 'multiple-bttp-trial-timestamp';
  const BTTP_TRIAL_DURATION_HOURS = _exports.BTTP_TRIAL_DURATION_HOURS = 24;
});